import { Component, OnInit, Inject, DOCUMENT } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
//import { TranslateService } from '@ngx-translate/core';
import { SettingService } from 'src/app/shared/services/setting.service';
import { TranslationService } from 'src/app/shared/services/translation.service';


@Component({
    selector: 'app-policies-page',
    templateUrl: './policies-page.component.html',
    styleUrls: ['./policies-page.component.scss'],
    standalone: false
})
export class PoliciesLandingPageComponent implements OnInit {
  policies: string;
  lang: string;

  constructor(
    private route: ActivatedRoute,
    //public translate: TranslateService,
    private translationService: TranslationService,
    private router: Router,
    private settingService: SettingService,
    @Inject(DOCUMENT) private document: Document // ✅ inject Document
  ) {}

  ngOnInit() {
     const currentUrl = this.router.url;
  if (currentUrl.includes('/data-privacy-contact/')) {
    console.log("Data Privacy Contact page detected, skipping merchantId checks");
    return;
  }
    const language = this.route.snapshot.paramMap.get('language');
    if (language) {
      this.lang = language;
      if (language === 'en' || language === 'fr') {
        this.translationService.setLanguage(language);
      } else {
        this.router.navigate(['/policies']);
      }
    } else {
      this.lang = this.translationService.getLanguage() || 'en';
    }
    this.getPolicies();
  }

  getPolicies() {
    this.settingService.getSAPolicies(this.lang).subscribe(async (policies) => {
      this.policies = policies;
    });
  }

  openPrivacyContactPage(event: Event) {
  event.preventDefault();
  const language = this.lang || 'en';
  const baseHref = this.document.getElementsByTagName('base')[0]?.getAttribute('href') || '/';
  const url = `${baseHref}data-privacy-contact/${language}`;
  window.open(url, '_blank');
}

goToDataPrivacy(event: Event) {
  event.preventDefault();
  const language = this.lang || 'en';
  console.log('Navigating to: /data-privacy-contact/' + language);
  this.router.navigate(['/data-privacy-contact', language]).then(success => {
    console.log('Navigation success:', success);
  });
}


}
